export default "__VITE_ASSET__Cvq3Hc7J__";